import firebase from "store/firebase";
import "firebase/firestore";

import { eventFromDoc } from "./utils";
import { AnyAction, Dispatch } from "redux";
import { subscribe } from "./listen-change";
import type { RootState } from "store/reducer";
import { StoreError } from "store/errors";
import { loadIdResource } from "store/util/id-resource";
import {
  EVENTS_ACTION_TYPES,
  TastingEvent,
  eventsActions,
} from "./reducer";

// Re-exported aliases for legacy callers / tests that import these symbolic
// names directly. The underlying strings live on EVENTS_ACTION_TYPES.
export const ACTION_EVENTS_ITEM_LOADING = EVENTS_ACTION_TYPES.startedLoading;
export const ACTION_EVENTS_ITEM_LOAD = EVENTS_ACTION_TYPES.loaded;
export const ACTION_EVENTS_ITEM_LOAD_ERROR = EVENTS_ACTION_TYPES.errored;

export default function loadItem(id: string) {
  return async (
    dispatch: Dispatch<AnyAction>,
    getState: () => RootState
  ) => {
    return loadIdResource<TastingEvent, RootState>(
      id,
      async (assertActive) => {
        const { auth } = getState();
        if (!auth.user?.email) {
          throw new StoreError("No current user.");
        }
        const doc = await firebase
          .firestore()
          .collection("events")
          .doc(id)
          .get();
        const item = eventFromDoc(doc);
        assertActive();
        // Subscribe to the user's related-events listener. Using the
        // subscription registry inside listen-change means a fresh subscribe
        // replaces only that user's previous listener, not every other event
        // listener globally — which the legacy singleton did.
        subscribe(auth.user.email);
        return item;
      },
      {
        actions: eventsActions,
        selectSlice: (root) => root.events,
      }
    )(dispatch as any, getState);
  };
}
